import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { useAuthStore } from '@/stores/authStore';
import { PoolFilters } from '@/types/pool';
import { isBorrower, isInvestor } from '@/utils/user';
import InvestorFiltersHeaderSection from './favoriteFilters/InvestorFiltersHeaderSection';

type FiltersHeaderProps = {
  onLoadFilter: (filters: PoolFilters) => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
  getCurrentFilters: () => PoolFilters;
  hasFiltersChanged: boolean;
};

export default function FiltersHeader({
  onLoadFilter,
  onApplyFilters,
  onClearFilters,
  getCurrentFilters,
  hasFiltersChanged,
}: FiltersHeaderProps) {
  const user = useAuthStore((state) => state.user);
  const isInvestorUser = isInvestor(user);
  const showBorrowerView = isBorrower(user);
  const [activeFilterId, setActiveFilterId] = useState<number | null>(null);

  const handleClearFilters = () => {
    setActiveFilterId(null);
    onClearFilters();
  };

  return (
    <div className="flex flex-wrap items-center gap-3 w-full">
      {/* Investor view */}
      {isInvestorUser && (
        <InvestorFiltersHeaderSection
          onLoadFilter={onLoadFilter}
          getCurrentFilters={getCurrentFilters}
          hasFiltersChanged={hasFiltersChanged}
          activeFilterId={activeFilterId}
          onActiveFilterChange={setActiveFilterId}
        />
      )}

      {/* Borrower view*/}
      {showBorrowerView && <h2 className="text-lg font-semibold text-[#113D7B] font-avenir">Filter Pools</h2>}

      {/* Action buttons */}
      <div className="flex items-center gap-3 sm:ml-auto">
        <Button onClick={handleClearFilters} variant="secondary">
          Clear All
        </Button>
        <Button onClick={onApplyFilters} variant="primary">
          Apply Filters
        </Button>
      </div>
    </div>
  );
}
